function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b65614d0-e117-4320-85aa-34d0c2c36a80",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1174 975.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "fa0b04e1-75b9-4f65-a8d3-8f45311f599e",
    "data-name": "Dotted line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549,389.78h-5v-6h5Zm-17,0H520v-6h12Zm-24,0H496v-6h12Zm-24,0H472v-6h12Zm-24,0H448v-6h12Zm-24,0H424v-6h12Zm-24,0H400v-6h12Zm-24,0H376v-6h12Zm-24,0H352v-6h12Zm-24,0H328v-6h12Zm-24,0H304v-6h12Zm-24,0H280v-6h12Zm-19-5h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-12h6Zm520-16h-6v-12h6Zm-520-8h-6v-9h9v6h-3Zm507-3H768v-6h12Zm-24,0H744v-6h12Zm-24,0H720v-6h12Zm-24,0H696v-6h12Zm-24,0H672v-6h12Zm-24,0H648v-6h12Zm-24,0H624v-6h12Zm-24,0H600v-6h12Zm-24,0H576v-6h12Zm-24,0H552v-6h12Zm-24,0H528v-6h12Zm-24,0H504v-6h12Zm-24,0H480v-6h12Zm-24,0H456v-6h12Zm-24,0H432v-6h12Zm-24,0H408v-6h12Zm-24,0H384v-6h12Zm-24,0H360v-6h12Zm-24,0H336v-6h12Zm-24,0H312v-6h12Zm-24,0H288v-6h12Z",
    style: {
      fill: "#f5b3a5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "f6b428ab-4d93-434b-b9ff-8d4080b6e0d3",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.75,
    y: 221.61,
    width: 257,
    height: 108,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.75,332.61h-263v-114h263Zm-257-6h251v-102h-251Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.88,296.21a32.48,32.48,0,0,1-50.26,0,26,26,0,0,1,21-19,13,13,0,1,1,8.22,0A26,26,0,0,1,211.88,296.21Z",
    style: {
      fill: "#2563f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75,310.61a35,35,0,1,1,27.06-12.81A34.84,34.84,0,0,1,186.75,310.61Zm0-65a30,30,0,1,0,30,30A30,30,0,0,0,186.75,245.61Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.25,
    y: 247.11,
    width: 59,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.25,
    y: 273.11,
    width: 108,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.25,
    y: 299.11,
    width: 108,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b85b50f7-2f19-4ea1-8a18-a1b0b732a343",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 195.78,
    width: 714,
    height: 634,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174,832.78H454v-640h720Zm-714-6h708v-628H460Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 195.78,
    width: 714,
    height: 79.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174,278.28H454v-85.5h720Zm-714-6h708v-73.5H460Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 417.28,
    width: 5,
    height: 312,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798,
    y: 417.78,
    width: 5,
    height: 312,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890,
    y: 417.78,
    width: 5,
    height: 312,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 984,
    y: 417.78,
    width: 5,
    height: 312,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075,
    y: 417.78,
    width: 5,
    height: 312,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 490.28,
    width: 375.5,
    height: 44,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.5,536.78H611v-49H991.5Zm-375.5-5H986.5v-39H616Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 550.28,
    width: 281.5,
    height: 44,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.5,596.78H611v-49H897.5Zm-281.5-5H892.5v-39H616Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 610.28,
    width: 189.5,
    height: 44,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.5,656.78H611v-49H805.5Zm-189.5-5H800.5v-39H616Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 670.28,
    width: 96.5,
    height: 44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.5,716.78H611v-49H712.5Zm-96.5-5h91.5v-39H616Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 430.28,
    width: 417,
    height: 44,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033,476.78H611v-49h422Zm-417-5h412v-39H616Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 443.28,
    width: 32,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 456.78,
    width: 52,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 501.28,
    width: 32,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 514.78,
    width: 52,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 561.28,
    width: 32,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 574.78,
    width: 52,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 619.28,
    width: 32,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 632.78,
    width: 52,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 677.28,
    width: 32,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 690.78,
    width: 52,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 322.28,
    width: 209,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 360.78,
    width: 261,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,752c0,4.29-1.73,7.23-5.26,7.23s-5.16-3.22-5.18-7.14,1.7-7.18,5.28-7.18S618,748.16,618,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S610.81,748.82,610.83,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.91,748h0l-2.64,1.26-.53-2.43,3.66-1.71h2.69V759h-3.14Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.84,752c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S716.84,748.16,716.84,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S709.63,748.82,709.66,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.58,688.64h0l-2.65,1.26-.53-2.43,3.67-1.71h2.68v13.86h-3.13Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.5,692.63c0,4.28-1.72,7.22-5.26,7.22s-5.16-3.22-5.18-7.14,1.7-7.18,5.28-7.18S696.5,688.83,696.5,692.63Zm-7.18.08c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S689.3,689.49,689.32,692.71Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.78,759v-2l1.79-1.62c3-2.71,4.5-4.27,4.54-5.89,0-1.13-.68-2-2.28-2a5,5,0,0,0-3,1.15l-.92-2.33a7.71,7.71,0,0,1,4.54-1.42c3.13,0,4.86,1.83,4.86,4.35,0,2.32-1.68,4.17-3.69,6l-1.28,1.07v0h5.23V759Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.84,752c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S811.84,748.16,811.84,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S804.63,748.82,804.66,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.78,640v-2l1.79-1.62c3-2.71,4.5-4.27,4.54-5.89,0-1.13-.68-2-2.28-2a5,5,0,0,0-3,1.15l-.92-2.33a7.71,7.71,0,0,1,4.54-1.42c3.13,0,4.86,1.83,4.86,4.35,0,2.32-1.68,4.17-3.69,6l-1.28,1.07v0h5.23V640Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.84,633c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S788.84,629.16,788.84,633Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S781.63,629.82,781.66,633Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.35,755.77a7.65,7.65,0,0,0,3.22.85c1.69,0,2.54-.81,2.54-1.85,0-1.37-1.36-2-2.79-2H885v-2.33h1.25c1.09,0,2.48-.42,2.48-1.6,0-.83-.69-1.45-2.05-1.45a6.23,6.23,0,0,0-2.9.84l-.66-2.35a8.7,8.7,0,0,1,4.28-1c3,0,4.61,1.55,4.61,3.45a3.32,3.32,0,0,1-2.54,3.22v0a3.45,3.45,0,0,1,3,3.37c0,2.45-2.15,4.24-5.67,4.24a8.23,8.23,0,0,1-4.12-1Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.84,752c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S904.84,748.16,904.84,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S897.63,748.82,897.66,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.35,576.77a7.65,7.65,0,0,0,3.22.85c1.69,0,2.54-.81,2.54-1.85,0-1.37-1.36-2-2.79-2H863v-2.33h1.25c1.09,0,2.48-.42,2.48-1.6,0-.83-.69-1.45-2.05-1.45a6.23,6.23,0,0,0-2.9.84l-.66-2.35a8.7,8.7,0,0,1,4.28-1c3,0,4.61,1.55,4.61,3.45a3.32,3.32,0,0,1-2.54,3.22v0a3.45,3.45,0,0,1,3,3.37c0,2.45-2.15,4.24-5.67,4.24a8.23,8.23,0,0,1-4.12-1Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.84,573c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S882.84,569.16,882.84,573Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S875.63,569.82,875.66,573Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.51,759v-3.31h-6.14v-2.11l5.25-8.44h4v8.12h1.67v2.43h-1.67V759Zm0-5.74v-3.07c0-.83,0-1.68.11-2.58h-.09c-.44.9-.81,1.71-1.27,2.58l-1.86,3v0Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.84,752c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S998.84,748.16,998.84,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S991.63,748.82,991.66,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.51,519v-3.31h-6.14v-2.11l5.25-8.44h4v8.12h1.67v2.43h-1.67V519Zm0-5.74v-3.07c0-.83,0-1.68.11-2.58h-.09c-.44.9-.81,1.71-1.27,2.58l-1.86,3v0Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.84,512c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S976.84,508.16,976.84,512Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S969.63,508.82,969.66,512Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.51,459v-3.31h-6.14v-2.11l5.25-8.44h4v8.12h1.67v2.43h-1.67V459Zm0-5.74v-3.07c0-.83,0-1.68.11-2.58h-.09c-.44.9-.81,1.71-1.27,2.58l-1.86,3v0Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.86,447.75h-5.37l-.3,2.14a5.08,5.08,0,0,1,.89-.05,6.29,6.29,0,0,1,3.65,1,3.94,3.94,0,0,1,1.68,3.47c0,2.58-2.21,4.86-5.94,4.86a8.73,8.73,0,0,1-3.86-.79l.57-2.43a8,8,0,0,0,3.14.68c1.34,0,2.77-.64,2.77-2.11s-1.13-2.3-3.9-2.3a11.46,11.46,0,0,0-1.88.13l.92-7.27h7.63Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075,747.75h-5.37l-.3,2.14a5.14,5.14,0,0,1,.9,0,6.28,6.28,0,0,1,3.64,1,3.92,3.92,0,0,1,1.68,3.47c0,2.58-2.21,4.86-5.94,4.86a8.73,8.73,0,0,1-3.86-.79l.57-2.43a8,8,0,0,0,3.14.68c1.34,0,2.77-.64,2.77-2.11s-1.13-2.3-3.9-2.3a11.46,11.46,0,0,0-1.88.13l.92-7.27H1075Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.84,752c0,4.29-1.73,7.23-5.27,7.23s-5.15-3.22-5.18-7.14,1.71-7.18,5.29-7.18S1087.84,748.16,1087.84,752Zm-7.18.09c0,3.18.74,4.69,2,4.69s1.94-1.58,1.94-4.73-.66-4.69-2-4.69S1080.63,748.82,1080.66,752Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1096.5 731.78 611 731.78 611 411.28 616 411.28 616 726.78 1096.5 726.78 1096.5 731.78",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 237.28,
    r: 12.5,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5,252.28a15,15,0,1,1,15-15A15,15,0,0,1,498.5,252.28Zm0-25a10,10,0,1,0,10,10A10,10,0,0,0,498.5,227.28Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.82,
    cy: 237.28,
    r: 12.5,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.82,252.28a15,15,0,1,1,15-15A15,15,0,0,1,545.82,252.28Zm0-25a10,10,0,1,0,10,10A10,10,0,0,0,545.82,227.28Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.14,
    cy: 237.28,
    r: 12.5,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.14,252.28a15,15,0,1,1,15-15A15,15,0,0,1,593.14,252.28Zm0-25a10,10,0,1,0,10,10A10,10,0,0,0,593.14,227.28Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "a1beea61-202f-487c-841c-1ec19245bcfc",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.95,
    y: 3,
    width: 133.67,
    height: 127.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.63,133.5H476V0H615.63ZM482,127.5H609.63V6H482Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.89,
    y: 21.58,
    width: 101.8,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.69 111.93 492.39 111.93 492.39 54.93 497.39 54.93 497.39 106.93 596.69 106.93 596.69 111.93",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.93 110.87 492.85 107.98 522.33 66.49 549.27 93.44 594.81 41.96 598.56 45.27 549.5 100.73 522.98 74.21 496.93 110.87",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.87,
    cy: 71.89,
    r: 4.63,
    style: {
      fill: "#2563f6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "af634150-1d55-4155-9f5e-ed83fc0676e7",
    "data-name": "Woman"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,853.78s15,36,134,38c0,0,84-9,92-49l-13-34H122Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.93,774.78s-19.87,33.38-32.05,99.07l-13.13,98.93H220.23l67.67-198Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84,770.48S334.59,908.61,329,972.78h-149l22-193.8Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.82,
    y: 907.65,
    width: 132.72,
    height: 5,
    transform: "translate(-696.84 837.59) rotate(-70.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,611.81l-4-60.86s51.91,1.67,7.53-83.74l-70.62,27.67L220.23,547l-6,65.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.48,614.78l6.22-67.57-13.18-53.86,74.76-29.28,1,2c18.28,35.18,22.85,60.46,13.6,75.16-6,9.48-15.89,11.63-20.69,12.1l4,61Zm-1.06-118.37,12.34,50.43-5.8,62.9,54.9-.41-4-61,2.75.09c.51,0,12.71.22,19.06-9.94,5.55-8.86,7.75-27.86-12.8-68.14Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.81,503.39s-7.8-13-15.71-3.59c-3.36,4-3,14.4,10.51,18,0,0,3.68,23.37-19.88,27.22,0,0-31.73-27.9-23.77-62.46,0,0-40.13,12.95-49.23-23.71-2.74-11,3-32.63,27.35-36.22,12-1.77,34.59,2.72,36.93,31.77,0,0,49.17-32.22,75.74,19.38C285.75,473.8,269.09,500.78,243.81,503.39Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,586.78s16,5,26,19c0,0,19,23,16,40l-9,11-46-45Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.26,568.7c4.58-10.08-4.58-13.74-4.58-13.74,4.58-11.91-7.33-16.49-7.33-16.49,1.29-6.39-1.46-9.41-4.67-10.84a9.36,9.36,0,0,0-10.76,2.47l-13,14.78-1.36-3.5c6.69-15.92,3.43-24.2.24-28.08a3.41,3.41,0,0,0-5.55.37c-5.41,8.81-19.72,32.33-20.71,36h0c-3.76,14-3.76,38.23-3.76,38.23l-13.24,24.74,26.56,25.64,19.65-33.89c8.25-.91,38.59-22.78,38.59-22.78C522.88,575.23,517.26,568.7,517.26,568.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,642.33l-30.22-29.17,13.84-25.86c0-4,.33-25.22,3.83-38.25,1-3.63,12-22,21-36.69a5.92,5.92,0,0,1,9.62-.65c3.58,4.38,6.57,12.43,1.71,26.5l8.55-9.75a11.77,11.77,0,0,1,13.65-3.12c2.8,1.25,7.13,4.38,6.41,11.7a18.18,18.18,0,0,1,4.48,3.52,13.58,13.58,0,0,1,3.11,13.23,12.27,12.27,0,0,1,4.57,5.47,12.43,12.43,0,0,1-.15,9.09c2.14,3.33,3.93,9.37-.83,14.92l-.19.23-.25.17c-3,2.17-28.59,20.47-38.45,23Zm-24-30.15,22.9,22.11,18.68-32.22,1.26-.13c5.49-.61,25.58-13.82,37.15-22.14,3.64-4.52.11-9-.31-9.48l-1-1.21.64-1.44c1.14-2.51,1.36-4.7.65-6.51a7.88,7.88,0,0,0-3.9-3.88l-2.24-.94.85-2.28c3.55-9.22-4.93-12.87-5.9-13.26L502.5,540l.4-2c1.1-5.45-1.32-7.21-3.24-8.06a6.87,6.87,0,0,0-7.86,1.83l-15.67,17.88-3.23-8.29.39-.93c6.36-15.11,3.12-22.48.62-25.53a1,1,0,0,0-.78-.34.92.92,0,0,0-.71.44C460.61,534.22,452.6,548.1,452,550.34c-3.62,13.51-3.67,37.35-3.67,37.59v.63Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.18,587.25,384,668l-45.9-74.6a41.17,41.17,0,0,0-23.44-17.92l-40.27-11s1.83,43.91-63.05-4.11L138.7,589.11a41.18,41.18,0,0,0-23.82,31.72S86.46,754.52,87,798.79c.25,21,2.74,30.87,23,33.49L108,853.78s40-16,117-21c72-3,109,10,109,10l-16.47-96.31L369,776.54a36.26,36.26,0,0,0,51.48-16.67L481,645.78s-17-3-31-20S439.18,587.25,439.18,587.25Z",
    style: {
      fill: "#2563f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.78,356.94l-56,233.38a6.81,6.81,0,0,0,5.1,8.21h0a6.79,6.79,0,0,0,8.15-5.19L525.9,358.8a4.16,4.16,0,0,0-3.14-4.95h0A4.16,4.16,0,0,0,517.78,356.94Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.58,661.34l-17.23,112.5c-1,6.75,3,13,8.92,13.87l66.28,10.15c6,.91,11.63-3.82,12.66-10.57l17.23-112.5c1-6.75-3-13-8.92-13.88l-66.28-10.15C274.28,649.85,268.61,654.59,267.58,661.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,800.47a11.49,11.49,0,0,1-1.84-.14L258.9,790.19c-7.32-1.12-12.26-8.63-11-16.73L265.11,661a15.64,15.64,0,0,1,5.35-9.7,12.7,12.7,0,0,1,10.16-3l66.27,10.15a12.71,12.71,0,0,1,8.81,5.87,15.64,15.64,0,0,1,2.21,10.86l-17.23,112.5C339.55,795.08,333.62,800.47,327,800.47Zm-57-138.75L252.82,774.21c-.82,5.38,2.24,10.33,6.83,11l66.28,10.15c4.58.71,9-3.1,9.81-8.48L353,674.41a10.74,10.74,0,0,0-1.47-7.4,7.8,7.8,0,0,0-5.36-3.63l-66.28-10.14a7.77,7.77,0,0,0-6.2,1.86,10.65,10.65,0,0,0-3.61,6.62Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.17,662.9,257.94,775.4c-1,6.75,3,13,8.92,13.88l66.28,10.15c6,.91,11.63-3.82,12.66-10.58L363,676.36c1-6.76-3-13-8.92-13.88l-66.28-10.15C281.87,651.42,276.2,656.15,275.17,662.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,802a12.77,12.77,0,0,1-1.84-.14l-66.28-10.15c-7.31-1.12-12.25-8.62-11-16.73l17.23-112.5a15.67,15.67,0,0,1,5.35-9.7,12.69,12.69,0,0,1,10.16-3L354.48,660a12.68,12.68,0,0,1,8.81,5.87,15.62,15.62,0,0,1,2.21,10.85l-17.23,112.5C347.14,796.65,341.21,802,334.6,802Zm-57-138.76-17.23,112.5c-.82,5.38,2.24,10.33,6.83,11L333.52,797c4.58.71,9-3.11,9.81-8.48L360.56,676a10.73,10.73,0,0,0-1.47-7.4,7.8,7.8,0,0,0-5.36-3.63L287.45,654.8a7.8,7.8,0,0,0-6.2,1.86,10.7,10.7,0,0,0-3.61,6.62Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,831.78s-13-5-14-34c0,0,0-22.44,10.52-29.72C221.52,768.06,245,794.78,225,831.78Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,768.78s-4.93,10-5.94,19.17c-1.56,14.33.94,21.83.94,21.83l46-13c6.43.67,17-4.21,17-4.21l32.36-19.74,9.77-12.1a4.17,4.17,0,0,0,.94-2.64,4.21,4.21,0,0,0-7.36-2.79l-7,7.86L298.1,766l9-6.48,12.61-17.68a3.91,3.91,0,0,0,.71-2.24,4,4,0,0,0-.65-2.17,3.88,3.88,0,0,0-5.85-.68L302.88,747l-11,7.2,10.54-11.88,12.77-13.76a4.92,4.92,0,0,0,1.33-3.38,5,5,0,0,0-1.1-3.13,5,5,0,0,0-6.88-.82l-14.33,10.94-15.14,11.4,7.69-11.25L302,720.67a5.51,5.51,0,0,0-6.28-9L277.56,723l-18.75,19.38-.29-14.88c-.68-11.22-8.22-10.15-8.22-10.15l-6.19,23.49-1,26.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,812.28a2.51,2.51,0,0,1-2.37-1.71c-.11-.33-2.66-8.19-1-22.89,1-9.49,6-19.58,6.18-20a2.51,2.51,0,0,1,2.12-1.39l20.85-1,.88-24.52a3.31,3.31,0,0,1,.08-.55l6.19-23.49a2.49,2.49,0,0,1,2.07-1.84,9.12,9.12,0,0,1,6.68,2c2.62,2.14,4.09,5.66,4.38,10.45a.31.31,0,0,1,0,.1l.17,8.87,14.57-15.06a3.4,3.4,0,0,1,.47-.38l18.18-11.37a8,8,0,0,1,12.26,6.79,8,8,0,0,1-1.16,4.14l1.54-1.18a7.44,7.44,0,0,1,10.34,1.23,7.6,7.6,0,0,1,1.66,4.71,7.5,7.5,0,0,1-2,5.09L313.64,734a6.37,6.37,0,0,1,9.32,5.66,6.31,6.31,0,0,1-1.17,3.68L316,751.48a7.33,7.33,0,0,1,1.33-.05,6.71,6.71,0,0,1,4.81,10.91l-9.77,12.1a2.36,2.36,0,0,1-.65.57l-32.36,19.73a2,2,0,0,1-.25.14c-.44.2-10.75,4.93-17.79,4.47l-45.59,12.84A2.71,2.71,0,0,1,215,812.28Zm6.63-41.08c-1.31,2.94-4.35,10.3-5.08,17a64.55,64.55,0,0,0,.29,18.44l43.51-12.25a2.5,2.5,0,0,1,.94-.08c4.63.49,12.66-2.62,15.54-3.93L308.7,771l9.5-11.77a1.72,1.72,0,0,0,.38-1.07,1.68,1.68,0,0,0-.3-1,1.7,1.7,0,0,0-2.69-.17l-7,7.86a2.52,2.52,0,0,1-1.1.72l-8.65,2.81a2.5,2.5,0,0,1-2.23-4.41l8.7-6.24,12.37-17.34a1.35,1.35,0,0,0,.25-.79,1.38,1.38,0,0,0-.24-.78,1.34,1.34,0,0,0-1-.59,1.37,1.37,0,0,0-1.11.36l-11.07,10.25a2.51,2.51,0,0,1-.32.25l-11,7.2a2.5,2.5,0,0,1-3.25-3.75l10.54-11.88,12.81-13.8a2.44,2.44,0,0,0,.66-1.68,2.52,2.52,0,0,0-.55-1.57,2.49,2.49,0,0,0-3.41-.4l-14.34,10.95-15.14,11.41a2.5,2.5,0,0,1-3.57-3.4l7.68-11.26a2.53,2.53,0,0,1,.55-.58l15.22-11.65a3,3,0,0,0,1.18-2.4,3.08,3.08,0,0,0-.45-1.59,3,3,0,0,0-1.88-1.34,3,3,0,0,0-2.28.38L279.15,725,260.6,744.11a2.49,2.49,0,0,1-4.29-1.69L256,727.59c-.21-3.27-1.09-5.63-2.56-6.83a4.21,4.21,0,0,0-1.29-.72L246.6,741.2l-1,26.54a2.49,2.49,0,0,1-2.37,2.4Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.38,585.86a8.08,8.08,0,0,1-4.39-1.21c-2.66-1.7-4-4.93-4-9.59v-1.22l27.86-21.67,3.07,3.94L488,576.25c.15,2.12.72,3.58,1.64,4.18,1.3.84,3.51.23,4.36-.12l22.25-14.09,2.67,4.23-22.7,14.35A12.49,12.49,0,0,1,491.38,585.86Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.06,591.76a7.55,7.55,0,0,1-5-1.61c-2.15-1.84-2.69-4.88-1.61-9l4.84,1.27c-.62,2.37-.4,3.6,0,4,1,.86,4.62.22,7.23-.89l2,4.58A20.43,20.43,0,0,1,501.06,591.76Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.13,577.53c-.61-.08-6.08-1-8.12-5.2-1.25-2.59-.88-5.61,1.09-9l.16-.28,25.63-25.63,3.54,3.53-25.17,25.17c-.68,1.24-1.3,2.86-.75,4,.75,1.57,3.45,2.31,4.34,2.45Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332 669.78 352 672.78 349 691.78 329 688.78 332 669.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,694.62l-24.94-3.74,3.78-23.94,24.94,3.74Zm-19.22-7.94,15.06,2.26,2.22-14.06-15.06-2.26Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,773.28a2.53,2.53,0,0,1-1.87-.84,2.48,2.48,0,0,1-.6-2l11-75a2.5,2.5,0,0,1,4.94.72l-10.56,72.05,66-1.91a2.5,2.5,0,0,1,.14,5l-69,2Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,835.28a2.5,2.5,0,0,1-.07-5l113-3a2.47,2.47,0,0,1,2.56,2.43,2.5,2.5,0,0,1-2.43,2.57l-113,3Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac7056c6-1cb3-4977-bab9-a5573c453d0f",
    "data-name": "Underline"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 970.28,
    width: 1083,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.f3b9391288f1d36bfd8b402bdf771f13.svg";
export { ForwardRef as ReactComponent };